// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b5092601","714":"84e62ca0"}[chunkId] + ".chunk.js";
};